export { DiscoverMWPayPage } from './DiscoverMWPayPage';
